import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck } from "lucide-react";
import mx from "@/locales/mx.json";
import { Button } from "@/components/ui/button";

/**
 * Thank-you page is HARD-LOCKED to Spanish (mx.json) per the specification.
 * It intentionally does not use the i18n provider so language never switches.
 */
export default function ThankYou() {
  const t = (key) => {
    const parts = key.split(".");
    let node = mx;
    for (const p of parts) node = node ? node[p] : undefined;
    return typeof node === "string" ? node : key;
  };

  return (
    <div
      data-testid="thankyou-page"
      className="min-h-screen bg-gradient-to-b from-[#F8FAFC] to-white flex flex-col"
    >
      <header className="bg-[#0F2942] text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 lg:h-20 items-center justify-between">
            <Link
              to="/"
              data-testid="thankyou-logo"
              className="flex items-center gap-3"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-[#059669]">
                <ShieldCheck size={22} strokeWidth={2.4} />
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-lg font-bold">Credanovelia</span>
                <span className="text-[11px] uppercase tracking-widest text-white/70">
                  Consultoría Financiera Oficial
                </span>
              </span>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-16 lg:py-24">
        <div className="max-w-2xl text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-[#047857]">
            <CheckCircle2 size={40} />
          </div>
          <h1 className="mt-6 font-serif text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight leading-tight">
            {t("thankyou.title")}
          </h1>
          <p className="mt-4 text-lg text-slate-700">{t("thankyou.subtitle")}</p>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            {t("thankyou.message")}
          </p>

          <div className="mt-10 mx-auto max-w-lg rounded-2xl border border-slate-200 bg-white p-6 text-left">
            <p className="text-sm font-semibold uppercase tracking-widest text-[#059669]">
              {t("thankyou.next_steps_title")}
            </p>
            <ol className="mt-4 space-y-3 text-slate-700">
              {[1, 2, 3].map((n) => (
                <li key={n} className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0F2942] text-white text-xs font-semibold">
                    {n}
                  </span>
                  <span>{t(`thankyou.step${n}`)}</span>
                </li>
              ))}
            </ol>
          </div>

          <Link to="/" data-testid="thankyou-back-home">
            <Button className="mt-10 h-12 rounded-full bg-[#059669] hover:bg-[#047857] text-white px-8 text-base">
              {t("thankyou.back_home")}
            </Button>
          </Link>
        </div>
      </main>

      <footer className="border-t border-slate-200 py-6 text-center text-xs text-slate-500">
        © 2026 Credanovelia S.A.P.I. de C.V., SOFOM E.N.R.
      </footer>
    </div>
  );
}
